import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'

import { fetchAccountAttribs as fetchAccount, fetchAccountSegments as fetchSegments } from './api'
import * as actions from './actions'

const fetchAccountAttribs = action$ => {
  return action$
    .ofType(actions.fetchAccountAttribs.toString())
    .pluck('payload')
    .switchMap(() => {
      return Observable.fromPromise(fetchAccount().then(res => res.json()))
        .map(actions.fetchAccountAttribsSuccess)
        .startWith(actions.fetchAccountAttribsPending())
        .catch(err => Observable.of(actions.fetchAccountAttribsFailed(err)))
    })
}

const fetchAccountSegments = action$ => {
  return action$
    .ofType(actions.fetchAccountSegments.toString())
    .pluck('payload')
    .mergeMap(({ index = 0, size = 1000 }) => {
      return Observable.fromPromise(fetchSegments(index, size).then(res => res.json()))
        .map(actions.fetchAccountSegmentsSuccess)
        .startWith(actions.fetchAccountSegmentsPending())
        .catch(err => Observable.of(actions.fetchAccountSegmentsFailed(err)))
    })
}

export const epic = combineEpics(fetchAccountAttribs, fetchAccountSegments)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/account/epic.js